module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-900-544.913d172.woff2";